"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceGenerationInvoiceLines = class UcInvoiceGenerationInvoiceLines extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    formatDataColumn(...args) {
        const [r, c, value, columnDefinition, row] = args;
        if (value == null) {
            return '';
        }
        const result = ['<div>'];
        if (value.net != null) {
            const net = this.$options.filters.number(value.net);
            result.push(`<div class="mb-1"><strong>${net}</strong></div>`);
        }
        if (value.quantity != null) {
            const quantity = this.$options.filters.number(value.quantity);
            result.push(`${quantity} ${row.unit}`);
        }
        result.push('</div>');
        return result.join('');
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    resizeTrigger;
    selectedItems;
    ts;
    stockColumns;
    values;
    async $$load_values() {
        return this.$fn.fetch('view_draft_invoice_lines').then(p => _.extend(p, {
            columns: this.stockColumns.concat(p.columns.map(field => ({
                field,
                name: field,
                textAlign: 'right',
                formatter: this.formatDataColumn
            })))
        }));
    }
    grouping;
    async $$load_grouping() {
        return [{
                getter: "partner",
                formatter: g => `<strong>${g.value}</strong>`,
                aggregateCollapsed: false,
                lazyTotalsCalculation: true,
            },
            {
                getter: "rental",
                formatter: g => `<strong>${g.value}</strong>`,
                aggregateCollapsed: "false,",
                lazyTotalsCalculation: true,
            },
        ];
    }
    ux;
    b_7315092382398562_columnDefaults;
    b_7315092382398562_options;
    dataMembers = ['resizeTrigger', 'selectedItems', 'ts', 'stockColumns', 'values', 'grouping', 'ux', 'b_7315092382398562_columnDefaults', 'b_7315092382398562_options'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                resizeTrigger: 0,
                selectedItems: [],
                ts: null,
                stockColumns: [{
                        field: "partner",
                        name: this.$fn.pgettext("InvoiceGeneration|ColumnHeader", "Partner"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "contract",
                            navigateOnIconClick: true,
                            params: {
                                id: "partner_id",
                            },
                        },
                    },
                    {
                        field: "rental",
                        name: this.$fn.pgettext("InvoiceGeneration|ColumnHeader", "Rental"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "rental",
                            navigateOnIconClick: true,
                            params: {
                                id: "rental_id",
                            },
                        },
                    },
                    {
                        field: "site",
                        name: this.$fn.pgettext("InvoiceGeneration|ColumnHeader", "Site"),
                        width: "30px",
                    },
                    {
                        field: "item",
                        name: this.$fn.pgettext("InvoiceGeneration|ColumnHeader", "Item"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "product",
                            navigateOnIconClick: true,
                            params: {
                                id: "product_id",
                            },
                        },
                    },
                    {
                        field: "serial_number",
                        name: this.$fn.pgettext("InvoiceGeneration|ColumnHeader", "Serial"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "meter",
                            navigateOnIconClick: true,
                            params: {
                                id: "meter_id",
                            },
                        },
                    },
                ],
                values: null,
                grouping: null,
                ux: null,
                b_7315092382398562_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                },
                b_7315092382398562_options: {
                    rowHeight: 40,
                    rowTopOffsetRenderType: "transform",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return;
        }
        return null;
    }
    async act_7315092382398562_setData_7288_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_7315092382398562_selectedRowsChanged(event, scope) {
        return await this.actions.evh_7315092382398562_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_7315092382398562_showModal_7290_getActionArgs($event) {
        return {
            name: "Invoice",
            props: {
                oid: $event.data.data.id,
                modal: true,
            },
        };
    }
    async evh_7315092382398562_command_7289_getWhen($event) {
        return $event.data.column.id === 'invoice_number';
    }
    async evh_7315092382398562_command(event, scope) {
        return await this.actions.evh_7315092382398562_command.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_reloadSlickgrid_7294_getActionArgs($event) {
        return {
            grid: "draftInvoices",
        };
    }
    async act_8564662037462133_request_7292_getActionArgs($event) {
        return {
            operation: "delete_draft_invoices",
            data: {
                invoices: this.selectedItems.map(p => p.id)
            },
        };
    }
    async evh_8564662037462133_click(event, scope) {
        return await this.actions.evh_8564662037462133_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_setData_7288 = new core_1.actions.SetDataAction({
            actionArgs: this.act_7315092382398562_setData_7288_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_selectedRowsChanged_7287 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_setData_7288,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_7315092382398562_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_selectedRowsChanged_7287],
        });
        const act_7315092382398562_showModal_7290 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7315092382398562_showModal_7290_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_command_7289 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_showModal_7290,
            event: "command",
            when: this.evh_7315092382398562_command_7289_getWhen,
            displayName: "showModal",
        });
        const evh_7315092382398562_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_command_7289],
        });
        const act_8564662037462133_reloadSlickgrid_7294 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_8564662037462133_reloadSlickgrid_7294_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_success_7293 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadSlickgrid_7294,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_8564662037462133_request_7292 = new core_1.actions.RequestAction({
            actionArgs: this.act_8564662037462133_request_7292_getActionArgs,
            displayName: "deleteItems",
            events: [evh_8564662037462133_success_7293],
        });
        const evh_8564662037462133_click_7291 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_request_7292,
            event: "click",
            displayName: "deleteItems",
        });
        const evh_8564662037462133_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_click_7291],
        });
        return {
            act_7315092382398562_setData_7288,
            evh_7315092382398562_selectedRowsChanged_7287,
            evh_7315092382398562_selectedRowsChanged,
            act_7315092382398562_showModal_7290,
            evh_7315092382398562_command_7289,
            evh_7315092382398562_command,
            act_8564662037462133_reloadSlickgrid_7294,
            evh_8564662037462133_success_7293,
            act_8564662037462133_request_7292,
            evh_8564662037462133_click_7291,
            evh_8564662037462133_click,
            deleteItems: act_8564662037462133_request_7292,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], UcInvoiceGenerationInvoiceLines.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceGenerationInvoiceLines.prototype, "onSize", null);
UcInvoiceGenerationInvoiceLines = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceGenerationInvoiceLines);
exports.default = UcInvoiceGenerationInvoiceLines;
vue_property_decorator_1.Vue.component("UcInvoiceGenerationInvoiceLines", UcInvoiceGenerationInvoiceLines);
